import { jsx as _jsx } from "react/jsx-runtime";
import { PillLink } from '@yonderland/andes-react';
export const QuickFilterItem = ({ quickLink }) => (_jsx(PillLink, { theme: "branded", variant: "secondary", href: `${quickLink.linkPath}${quickLink.queryStringParams || ''}`, size: "sm", children: quickLink.linkName }));
